var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCropDivWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7176 0.719603C16.2876 -0.239868 17.7124 -0.239867 18.2824 0.719603L33.7994 26.8412C34.3694 27.8007 33.6569 29 32.517 29H1.48299C0.343085 29 -0.369358 27.8007 0.200597 26.8412L15.7176 0.719603Z",
    fill: "#FFCA26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4319 9.52493L18.1889 19.8713H15.8184L15.5828 9.52493H18.4319ZM17.0037 24.3361C16.5571 24.3361 16.1742 24.1834 15.8552 23.8781C15.5411 23.5729 15.3841 23.2008 15.3841 22.7619C15.3841 22.3326 15.5411 21.9653 15.8552 21.66C16.1742 21.3548 16.5571 21.2021 17.0037 21.2021C17.4405 21.2021 17.8184 21.3548 18.1374 21.66C18.4613 21.9653 18.6233 22.3326 18.6233 22.7619C18.6233 23.0529 18.5472 23.3177 18.3951 23.5562C18.2478 23.7947 18.0515 23.9855 17.8061 24.1286C17.5656 24.2669 17.2982 24.3361 17.0037 24.3361Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropDivWarning);
export default __webpack_public_path__ + "static/media/cropDivWarning.c930c9f240bebf83cebe77479f6b36db.svg";
export { ForwardRef as ReactComponent };